import { render } from "./ViewClient.vue?vue&type=template&id=95de4412&scoped=true"
import script from "./ViewClient.vue?vue&type=script&lang=js"
export * from "./ViewClient.vue?vue&type=script&lang=js"

import "./ViewClient.vue?vue&type=style&index=0&id=95de4412&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-95de4412"]])

export default __exports__